import { useRef } from "react";
import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";
import { Calendar } from "@hassanmojab/react-modern-calendar-datepicker";
import * as calendarCustom from "../../assets/js/locateCalendar";
import clickOut from "../../assets/js/clickOut";

const Calendario = ({
  date,
  setDate,
  calendView,
  setCalendView,
  minimumDate,
  maximumDate
  // setactualizar,
}) => {
  const divCalendar = useRef();

  const hoy = new Date();
  const updateDate = (date) => {    
    const year = date.year.toString();
    const month = date.month.toString().padStart(2, 0);
    const day = date.day.toString().padStart(2, 0);
    date = new Date(`${year}/${month}/${day}`);
    setDate(date);
    // setactualizar(true);
    setCalendView("hide");
  };
  // devuelve la fecha en formato object (para el calendar)
  function fechaObjet(date) {
    return {
      day: date.getDate(),
      month: date.getMonth() + 1,
      year: date.getFullYear(),
    };
  }
  //cierra el calendario
  clickOut(divCalendar, () => {
    // setactualizar(true);
    setCalendView("hide");
  });

  return (
    <div
      style={{ left: 200 }}
      className={
        calendView === "hide" ? "calendario ocultar" : "calendario ver"
      }
    >
      {calendView === "reload" ? (
        ""
      ) : (
        <Calendar
          value={fechaObjet(date)}
          onChange={updateDate}
          slideAnimationDuration={"1s"}
          locale={calendarCustom.locale_es}
          maximumDate={maximumDate ? maximumDate:fechaObjet(hoy)}
          minimumDate={minimumDate}
          selectorStartingYear={minimumDate?.year}
          selectorEndingYear={maximumDate ? maximumDate.year : hoy.getFullYear()}
          colorPrimary="#00aedc"
          colorPrimaryLight="rgba(0,174,220,0.4)"
          shouldHighlightWeekends
        />
      )}
    </div>
  );
};

export default Calendario;
